import React from 'react';
import { IonIcon } from '@ionic/react';
import { arrowBack, menuOutline, searchOutline } from 'ionicons/icons';
import { useOrg } from '../hooks/useOrg';
import { useMoreSheet } from '../hooks/useMoreSheet';
import './su-components.css';

export interface AppHeaderProps {
  title?: string;
  /** Small line under the title (Home: "Last refreshed: HH:MM (GMT +5:30)"). */
  subtitle?: string | null;
  onBack?: () => void;
  onSearch?: () => void;
  onMenu?: () => void;
  /** Replaces the default search/menu icons. */
  rightAction?: React.ReactNode;
}

const AppHeader: React.FC<AppHeaderProps> = ({ title, subtitle, onBack, onSearch, onMenu, rightAction }) => {
  const { title: orgTitle } = useOrg();
  const more = useMoreSheet();
  const heading = title ?? orgTitle;
  // The legacy IonMenu is not rendered in the /app tree, so the menu icon opens the More sheet.
  const openMenu = onMenu ?? more.openSheet;
  return (
  <div className="su-appheader">
  <header className="su-header">
    {onBack && (
      <button type="button" className="su-icon-btn" aria-label="Back" onClick={onBack}>
        <IonIcon icon={arrowBack} />
      </button>
    )}
    <div className="su-header-text">
      <h1>{heading}</h1>
      {subtitle && <div className="su-header-sub">{subtitle}</div>}
    </div>
    {rightAction ?? (
      <>
        <button type="button" className="su-icon-btn" aria-label="Search" onClick={onSearch}>
          <IonIcon icon={searchOutline} />
        </button>
        <button type="button" className="su-icon-btn" aria-label="Menu" onClick={openMenu}>
          <IonIcon icon={menuOutline} />
        </button>
      </>
    )}
  </header>
  </div>
  );
};

export default AppHeader;
